import { RFP_OFFER_MEMBER_ROLE_ADMIN } from '@/utils/constants/rfp/rfpOfferMember/role';
/**
 * roleが管理者かどうか
 * @param role
 * @returns {boolean}
 */
export const isRfpRoleAdmin = (role) => role === RFP_OFFER_MEMBER_ROLE_ADMIN.value;
